import state from "../state";
import renderBoard from "./renderBoard";
import updateBounds from "./updateBounds";
export default function saveImage() {
    const padding = 50;
    const strokes = state.getStrokes();
    const bounds = updateBounds(strokes);
    if (!bounds) {
        return;
    }
    const tempCanvas = document.createElement("canvas");
    const tempCtx = tempCanvas.getContext("2d");
    if (!tempCtx) {
        return;
    }
    tempCanvas.width = Math.ceil(bounds.maxX - bounds.minX + padding * 2);
    tempCanvas.height = Math.ceil(bounds.maxY - bounds.minY + padding * 2);
    renderBoard(tempCanvas, tempCtx, strokes, {
        zoom: 1,
        panX: padding - bounds.minX,
        panY: padding - bounds.minY,
    });
    const croppedImage = tempCanvas.toDataURL("image/png");
    const link = document.createElement("a");
    link.href = croppedImage;
    link.download = "board-" + Date.now() + ".png";
    link.click();
}
